'use strict';
const Actions = require('../actions');
const Button = require('../../../../components/form/button.jsx');
const React = require('react');
const ReactHelmet = require('react-helmet');
const ReactRouter = require('react-router-dom');
const Spinner = require('../../../../components/form/spinner.jsx');
const Store = require('./store');

const Helmet = ReactHelmet.Helmet;
const Link = ReactRouter.Link;

class LoginPage extends React.Component {
    constructor(props) {

        super(props);


        this.input = {};
        this.state = Store.getState();
    }

    componentDidMount() {

        if (this.props.location.pathname === '/login/logout') {
            Actions.logout((err) => {
                if (!err) {
                    window.notify('success', `You've logged out successfully`);
                }
            })
        } else {
            Actions.getUserCreds();
        }

        this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));

        if (this.input.username) {
            this.input.username.focus();
        }
    }

    componentWillUnmount() {

        this.unsubscribeStore();
    }

    onStoreChange() {
        let newState = Store.getState();
        Actions.clearSuccess();
        this.setState(newState);
    }

    keyDown(e) {
        const caps_lock_on = e.getModifierState('CapsLock');
        this.setState({
            capsLock: caps_lock_on
        })
    }

    handleSubmit(event) {

        event.preventDefault();
        event.stopPropagation();

        const twoFactorToken = this.input.secret && this.input.secret.value;
        Actions.login({
            username: this.input.username.value,
            password: this.input.password.value,
            secret: twoFactorToken || ''
        }, (err) => {
            if (err) {

                // 2FA is required.
                if (err.statusCode === 499) {
                    setTimeout(() => {
                        this.setState({
                            showSecret: !err.twoFactorLinkSent,
                        });
                        this.input.secret.focus();
                    }, 200);

                    if (err.customMessage) {
                        window.notify('warning', err.customMessage);
                    }

                } else {
                    window.notify('error', err.message);
                }
            }
        });
    }

    render() {
        return (
            <section className="container">
                <Helmet>
                    <title>Sign in</title>
                </Helmet>
                <img src="/public/media/background-image.jpg" className="background-full-image"/>
                <div className="container center-flex-container">
                    <form className="default-form" onSubmit={ this.handleSubmit.bind(this) }>
                        <div className="logo-wrapper animated fadeInDown">
                            <img
                                className="login-logo"
                                src="/public/media/logo.png"
                            />
                        </div>
                        <div className={ `owl ${ this.state.focus ? 'password' : '' }` }>
                            <div className="hand"/>
                            <div className="hand hand-r"/>
                            <div className="arms">
                                <div className="arm"/>
                                <div className="arm arm-r"/>
                            </div>
                        </div>
                        <div className="form">
                            <div className="control">
                                <label htmlFor="email" className="fa fa-user"/>
                                <input id="email"
                                       autoCorrect="off"
                                       autoCapitalize="none"
                                       ref={ (c) => (this.input.username = c) }
                                       placeholder="Username" type="text"/>
                            </div>
                            <div className="control">
                                <label htmlFor="password" className="fa fa-asterisk"/>
                                <input id="password" placeholder="Password"
                                       autoCorrect="off"
                                       autoCapitalize="none"
                                       ref={ (c) => (this.input.password = c) }
                                       onKeyDown={ this.keyDown.bind(this) }
                                       onKeyUp={ this.keyDown.bind(this) }
                                       type="password"
                                       onBlur={ () => this.setState({ focus: false }) }
                                       onFocus={ () => this.setState({ focus: true }) }/>
                                { this.state.capsLock && <img className="caps-lock"
                                                              src="https://files.easybizy.net/files/__general/public/images/caps_lock.png"/> }
                            </div>

                            { this.state.secretRequired &&
                            <div
                                className={ `control hidden-control ${ this.state.showSecret ? 'hidden-control--visible' : '' }` }>
                                <label htmlFor="secret" className="fa fa-lock"/>
                                <input id="secret" placeholder="Secret digits"
                                       ref={ (c) => (this.input.secret = c) }
                                       type="text"/>
                            </div> }

                            <div
                                className={ `control hidden-control ${ !this.state.twoFactorLinkSent && 'hidden-control--visible' }` }>
                                <Button
                                    type="submit"
                                    inputClasses={ { 'submit-login-button': true } }
                                    disabled={ this.state.loading }>

                                    Log In
                                    <Spinner space="left" show={ this.state.loading }/>
                                </Button>
                            </div>

                            <Link to="/login/forgot" className="forgot-password-link btn btn-link">Forgot
                                password?</Link>

                        </div>
                    </form>
                </div>
                <div className="login-footer">
                    <div>
                        <a target="_blank" href="/privacy">מדיניות הפרטיות</a>
                        <a target="_blank" href="/terms-of-use">תנאי השימוש</a>
                    </div>
                </div>
            </section>
        );
    }
}


module.exports = LoginPage;



// WEBPACK FOOTER //
// ./client/pages/main/login/home/index.jsx